exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".align-right {\r\n    text-align: right;\r\n}\r\n\r\n.spacing {\r\n    margin-top: 50px;\r\n}\r\n\r\n.next-scene-button {\r\n  margin-top: 15px;\r\n}\r\n\r\n.next-scene-button:not(:first-child) {\r\n  margin-left: 15px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Repos/seeya/src/app/runner/game-runner/game-runner.component.css
// module id = ../../../../../src/app/runner/game-runner/game-runner.component.css
// module chunks = main